import { Tooltip, Typography } from '@mui/material'
import styles from './notificationV2.module.scss'

import { countUnreadNotifications, deleteNotification, readNotification } from '../../features/notificationSlice'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ButtonCustom from '../atoms/button/ButtonCustom'
import { setSettingsTab } from '../../features/authSlice'

export const NotificationV2 = ({ item, index }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const subscriptionTypes = [
        'Business Basic Subscription',
        'Business Pro Subscription',
        'Top Vendor Badge',
    ]

    const handleNotificationClick = (item) => {
        if (item?.status === 'unread') {
            dispatch(readNotification(item._id))
        }
        if (item?.link) {
            if (item?.type === 'Chat') {
                try {
                    const url = new URL(item.link, window.location.origin)
                    const groupId = url.searchParams.get('groupId')

                    if (groupId) {
                        navigate(url.pathname, { state: { selectedGroupId: groupId } })
                    } else if (item.senderId) {
                        navigate(item.link, { state: { selectedUserId: item.senderId } })
                    } else {
                        navigate(item.link)
                    }
                } catch (e) {
                    navigate(item.link, { state: { selectedUserId: item.senderId } })
                }
            } else {
                navigate(item.link)
            }
            if (subscriptionTypes.includes(item?.type)) {
                dispatch(setSettingsTab(4))
            }
        }
    }

    return (
        <li
            className={`${styles.notificationItem} ${item.raw.status === 'unread' ? styles.unread : ''}`}
            key={item?.raw?._id || index}
        >
            <div className={styles.contentRow}>
                <div
                    className={`${styles.notificationIcon} ${item.paymentSuccess && styles.paymentSuccess}`}
                >
                    {item.icon}
                </div>
                <div
                    className={styles.notificationContent}
                    onClick={() => handleNotificationClick(item.raw)}
                >
                    <div className={styles.textRow}>
                        <Typography variant="h4" className={styles.notificationTitle}>
                            {item.heading}
                        </Typography>
                        <Typography
                            variant="body1"
                            className={styles.notificationTime}
                        >
                            {item.time}
                        </Typography>
                    </div>
                    <Typography variant="body1" className={styles.notificationSubheading}>
                        {item.subheading}
                    </Typography>
                </div>
                <Tooltip
                    title="Dismiss"
                    placement="right"
                    disableInteractive
                    arrow
                >
                    <ButtonCustom
                        variant="outlined"
                        size="sm"
                        label="Role"
                        onClick={() => {
                            dispatch(deleteNotification(item.raw._id))
                            dispatch(countUnreadNotifications())
                        }}
                        className={styles.dismissButton}
                    >
                        <img
                            data-cy="dismiss-notification"
                            src="/images/trash-red.svg"
                            alt="dismiss"
                        />
                    </ButtonCustom>
                </Tooltip>
            </div>
        </li>
    )
}